import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";
import { Check, AlertTriangle, Info, XCircle } from "lucide-react";
import { cn } from "../../../utils/cn";

const toastStyles = cva("flex items-center gap-2 rounded-md px-3 py-2 text-bg shadow-md", {
  variants: {
    variant: {
      success: "bg-success",
      error: "bg-danger",
      info: "bg-ring",
      warning: "bg-warning",
    },
  },
  defaultVariants: { variant: "info" },
});

export interface ToastProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof toastStyles> {
  message: string;
}

export function Toast({ message, variant, className, ...props }: ToastProps) {
  const Icon =
    variant === "success"
      ? Check
      : variant === "error"
        ? XCircle
        : variant === "warning"
          ? AlertTriangle
          : Info;
  return (
    <div role="status" className={cn(toastStyles({ variant }), className)} {...props}>
      <Icon className="h-4 w-4" />
      <span className="text-sm">{message}</span>
    </div>
  );
}

export default Toast;
